import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export interface DownloadAuditTrailPayload {
  identifier: string;
  patient_mrn: string;
  visit_date: string;
  drug_name: string;
  org_id: string;
}

export const downloadAuditTrail = async (
  payload: DownloadAuditTrailPayload,
) => {
  try {
    const token = await getBearerToken();

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.DOWNLOAD_AUDIT_TRAIL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Download audit trail failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    return await response.json();
  } catch (error) {
    logError(error as Error, "Error in downloadAuditTrail");
    throw error;
  }
};
